import { render, staticRenderFns } from "./activation.vue?vue&type=template&id=a20db928&scoped=true&"
import script from "./activation.vue?vue&type=script&lang=js&"
export * from "./activation.vue?vue&type=script&lang=js&"
import style0 from "./activation.vue?vue&type=style&index=0&id=a20db928&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20db928",
  null
  
)

export default component.exports